import { makeStyles, CardHeader, CardContent, Button, ListItemAvatar, ListItem, ListItemText, ListItemSecondaryAction, List, Avatar, ListItemIcon, IconButton, useMediaQuery } from "@material-ui/core";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { CreateBraintreeCardForm } from "pages/CustomerBooking/Payment/CreateBraintreeCardForm";
import { useTrackEvent } from "util/trackEvent";

import braintree from 'braintree-web'
import { toast } from "react-hot-toast";
import { Alert } from "@material-ui/lab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaypal } from "@fortawesome/free-brands-svg-icons";
import { createNewCCPaymentMethod } from "services/payments.service";
import { getCardIcon } from "util/creditCard";
import { Delete } from "@material-ui/icons";
import { toasterror } from "util/toasterror";


const useStyles = makeStyles(theme => ({
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    '& > *': {
      marginLeft: theme.spacing(2),
    }
  },
}));
const CreateBraintreePaypalForm = ({
  onSuccess = () => { },
  onLoading = (bool) => { },
  braintreeToken

}) => {
  const classes = useStyles()
  const trackEvent = useTrackEvent()

  const [error, setError] = useState(null);


  const [paypalPayload, setPaypalPayload] = useState(null);
  const [btIntegration, setBtIntegration] = useState(null);

  const configureHeadlessPaypal = useCallback(
    async () => {
      onLoading(true)
      try {
        braintree.setup(braintreeToken, "custom", {
          paypal: {
            container: "paypal-container",
            // singleUse: true,
            intent: 'authorize',
            headless: true,
          },
          onPaymentMethodReceived: function (payload) {
            setPaypalPayload(payload)
          },
          onReady: function (integration) {
            onLoading(false)
            setBtIntegration(integration)
          },
          onError: function (err) {
            onLoading(false)
            console.log('CreateBraintreePaypalForm.jsx (44) # err', err);
            setError(err?.message)
          },
        })
      } catch (error) {
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details || error?.message)
      }
      return null
    }, [braintreeToken]
  );
  useEffect(
    () => {
      if (braintreeToken) {
        configureHeadlessPaypal()
      }
    }, [braintreeToken]
  );

  const onSubmit = useCallback(
    async () => {
      onLoading(true)
      try {
        const newPaymentParams = {
          label: 'Paypal',
          is_default: 0,
          nonce: paypalPayload?.nonce,
          gateway_type: 'BRAINTREE',
          is_paypal: true,
        }
        const results = await createNewCCPaymentMethod(newPaymentParams)
        onSuccess()
      } catch (error) {
        setError(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details || error?.message)
      } finally {
        onLoading(false)
      }

    }, [paypalPayload]
  );

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"),
    {
      noSsr: true,
    });
  return (
    <>
      <CardHeader title="Paypal" />
      <CardContent>
        <div id="paypal-container"></div>
        {paypalPayload ? (
          <List>
            <ListItem>
              <ListItemText
                primary={'Paypal'}
                secondary={paypalPayload?.details?.email}
              />
              <ListItemSecondaryAction>
                {
                  isMobile ? (
                    <IconButton
                      edge="end"
                      onClick={(evt) => {
                        evt.preventDefault()
                        setPaypalPayload(null)
                      }}
                      variant="text"
                    >
                      <Delete />
                    </IconButton>
                  ) : (
                    <Button onClick={(evt) => {
                      evt.preventDefault()
                      setPaypalPayload(null)
                    }}
                      variant="text"
                    >
                      Remove
                    </Button>
                  )
                }

              </ListItemSecondaryAction>
            </ListItem>
          </List>
        ) : (
          <Button onClick={(evt) => {
            evt.preventDefault()
            setPaypalPayload(null)
            btIntegration?.paypal?.initAuthFlow()
          }} variant="contained" color="primary">Add Paypal Account</Button>
        )}

      </CardContent>
      {error &&
        <CardContent>
          <Alert severity="error">
            {error}
          </Alert>
        </CardContent>
      }
      <CardContent>
        <div className={classes.actions}>
          <Button onClick={() => {
            trackEvent('Payment - Create Paypal - click Cancel', {})
            onSuccess()
          }}
            variant="outlined">Cancel
          </Button>
          <Button
            disabled={!paypalPayload}
            onClick={() => {
              trackEvent('Payment - Create Paypal - click Add Card', {})
              onSubmit()
            }} variant="contained" color="primary">Add Card</Button>
        </div>
      </CardContent>
    </>
  )
}

export { CreateBraintreePaypalForm }